import * as type from "../types/new-template";
import { EditorState } from "draft-js";

const initialState = {
  type: "email",
  emailTemplate: {
    title: null,
    type: "email",
    content: EditorState.createEmpty(),
    html: null,
  },
  smsTemplate: {
    title: null,
    type: "sms",
    message: null,
    messageData: EditorState.createEmpty(),
  },
  createTemplate: {
    status: null,
    loading: false,
    error: null,
  },
};

export const newTemplate = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_ADD_NEW_TEMPLATE:
      return {
        ...state,
        createTemplate: {
          ...state.createTemplate,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_ADD_NEW_TEMPLATE:
      return {
        ...state,
        createTemplate: {
          ...state.createTemplate,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_ADD_NEW_TEMPLATE:
      return {
        ...state,
        createTemplate: {
          ...state.createTemplate,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_ADD_NEW_TEMPLATE:
      return {
        ...state,
        createTemplate: {
          ...state.createTemplate,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.SET_NEW_TEMPLATE_TYPE:
      return {
        ...state,
        type: payload.variant,
      };
    case type.RESET_NEW_TEMPLATE_TYPE:
      return {
        ...state,
        type: null,
      };
    case type.SET_NEW_EMAIL_TEMPLATE_TITLE:
      return {
        ...state,
        emailTemplate: {
          ...state.emailTemplate,
          title: payload.title,
        },
      };
    case type.RESET_NEW_EMAIL_TEMPLATE_TITLE:
      return {
        ...state,
        emailTemplate: {
          ...state.emailTemplate,
          title: null,
        },
      };
    case type.SET_NEW_SMS_TEMPLATE_TITLE:
      return {
        ...state,
        smsTemplate: {
          ...state.smsTemplate,
          title: payload.title,
        },
      };
    case type.RESET_NEW_SMS_TEMPLATE_TITLE:
      return {
        ...state,
        smsTemplate: {
          ...state.smsTemplate,
          title: null,
        },
      };
    case type.SET_NEW_EMAIL_TEMPLATE_CONTENT:
      return {
        ...state,
        emailTemplate: {
          ...state.emailTemplate,
          content: payload.content,
        },
      };
    case type.RESET_NEW_EMAIL_TEMPLATE_CONTENT:
      return {
        ...state,
        emailTemplate: {
          ...state.emailTemplate,
          content: EditorState.createEmpty(),
        },
      };
    case type.SET_NEW_EMAIL_TEMPLATE_HTML:
      return {
        ...state,
        emailTemplate: {
          ...state.emailTemplate,
          html: payload.html,
        },
      };
    case type.RESET_NEW_EMAIL_TEMPLATE_HTML:
      return {
        ...state,
        emailTemplate: {
          ...state.emailTemplate,
          html: null,
        },
      };
    case type.SET_NEW_SMS_TEMPLATE_MESSAGE:
      return {
        ...state,
        smsTemplate: {
          ...state.smsTemplate,
          messageData: payload.message,
        },
      };
    case type.RESET_NEW_SMS_TEMPLATE_MESSAGE:
      return {
        ...state,
        smsTemplate: {
          ...state.smsTemplate,
          messageData: EditorState.createEmpty(),
        },
      };
    case type.SET_NEW_SMS_TEMPLATE_PLAINTEXT:
      return {
        ...state,
        smsTemplate: {
          ...state.smsTemplate,
          message: payload.message,
        },
      };
    case type.RESET_NEW_SMS_TEMPLATE_PLAINTEXT:
      return {
        ...state,
        smsTemplate: {
          ...state.smsTemplate,
          message: "",
        },
      };
    default:
      return state;
  }
};
